module.exports = __webpack_public_path__ + "static/media/croquet-golf-step-2.b0550a07.png";